import { FC } from "react";
import styles from "../../../styles/italianStory/ItalianStory.module.scss";
import ReadTime from "../../common/ReadTime";
import Tag from "../../common/Tag";
import WrittenBy from "./WrittenBy";
import { TagsEntity } from "../../../models/italianStory";

const ItaliaStoryTitle: FC<{
    text: string;
    author: string;
    readTime: string;
    tags?: TagsEntity[] | null;
    avatar?: string;
    colorAvatar?: string;
}> = ({ text, author, readTime, tags, avatar, colorAvatar }) => {
    return (
        <div className={styles.italianStoryTitle}>
            <div className="pt-2 pb-4 d-flex">
                {!!tags &&
                    tags.map(tag => (
                        <Tag
                            key={tag.label}
                            title={tag.label}
                            color={tag.color}
                            className={styles.italianStoryTitleTag}
                        />
                    ))}
            </div>
            <div className="pb-2">
                <ReadTime time={readTime} />
            </div>
            <div className={styles.articleTitle}>{text}</div>
            <WrittenBy
                borderAvatar={colorAvatar}
                avatar={avatar}
                author={author}
                className={styles.italianStoryTitleWrittenBy}
            />
        </div>
    );
};

export default ItaliaStoryTitle;
